module.exports = __webpack_public_path__ + "static/img/IMG_2684.167c9df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_2684.jpg
// module id = 1Zg1
// module chunks = 12